"use client";

import { c as _c } from "react/compiler-runtime";
import { useLanguage } from "~/translations/loader/use-language";
export default function AllJobsCtaHungary() {
  const $ = _c(2);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.hungary_allJobsCTA) {
    t0 = <div className="bg-gray-300 px-6 py-8 text-black xs:text-lg md:px-10 lg:text-xl"><div className="mx-auto max-w-screen-xl"><span dangerouslySetInnerHTML={{
          __html: t.hungary_allJobsCTA
        }} /></div></div>;
    $[0] = t.hungary_allJobsCTA;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}